import { Result } from '../../../Shared/Protocol/protocol-result'
import { HCPFlowService } from '../../../Services/HCP/flows/hcp-flow.service'
import {
  HCPFlowEnum,
  IHCPFlowStatus,
  IHCPFlowStatusInput,
} from '../../../Services/HCP/flows/hcp-flow.interface'

export class ManageHCPFlowStatusUseCase {
  constructor(private readonly hcpFlowService: HCPFlowService) {}

  public async listStatuses(flow: HCPFlowEnum): Promise<Result<IHCPFlowStatus[]>> {
    try {
      const result = await this.hcpFlowService.getFlowStatuses(flow)
      if (!result.isSuccess) return Result.fail(result.error as Error)
      const value = result.getValue()
      const items = Array.isArray(value) ? value : []
      return Result.ok(items as IHCPFlowStatus[])
    } catch (error: any) {
      return Result.fail(error)
    }
  }

  public async create(
    flow: HCPFlowEnum,
    payload: IHCPFlowStatusInput
  ): Promise<Result<IHCPFlowStatus>> {
    try {
      return await this.hcpFlowService.createFlowStatus(flow, payload)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

  public async update(
    flow: HCPFlowEnum,
    statusId: string,
    payload: Partial<IHCPFlowStatusInput>
  ): Promise<Result<IHCPFlowStatus>> {
    try {
      return await this.hcpFlowService.updateFlowStatus(flow, statusId, payload)
    } catch (error: any) {
      return Result.fail(error)
    }
  }
}
